import { notification } from 'antd';

export const showNotification = (description = '', title = 'Notification', type = 'info', placement = 'topRight') => {
  notification[type]({
    message: title || 'Notification',
    description: description || '',
    placement,
  });
};

export const showNotificationDuration = (duration, description = '', title = 'Notification', type = 'info', placement = 'topRight', key) => {
  notification[type]({
    message: title || 'Notification',
    description: description || '',
    placement,
    duration,
    key,
  });
};
